import { colors, makeStyles } from '@material-ui/core'

import helpers from 'helpers'
import constants from 'constants/index'

const {
  ACTIVE_STATUS_ID,
  AWAITING_APPROVAL_STATUS_ID,
  CHIP_STATUS_COLOR,
  DRAFT_STATUS_ID,
  EXPIRED_STATUS_ID,
  INACTIVE_STATUS_ID,
} = constants.documents

// O stylesheet é estático de propósito. A cor do chip depende do status do documento, mas resolver isso
// com uma factory `styles(status)` chamada no corpo do componente remonta a folha do JSS a cada render —
// e dentro deste modal, que re-renderiza a cada seleção de documento, as classes chegavam a ser
// descartadas e a linha perdia o layout. Uma classe por status + clsx resolve sem esse risco.
const styles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(2),
    minHeight: 60,
    padding: theme.spacing(1.5, 2),
    transition: theme.transitions.create('background-color'),
  },
  selectedRow: {
    backgroundColor: helpers.palette.hexToRgba(
      theme.palette.primary.main,
      0.06,
    ),
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(1.5),
    flex: 1,
    minWidth: 0,
  },
  infoText: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  titleLine: {
    display: 'flex',
    alignItems: 'baseline',
    gridGap: theme.spacing(1),
    minWidth: 0,
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  metaLine: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(1),
  },
  approvedLabel: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(0.5),
    color: theme.palette.partnerGreen.dark,
  },
  fileIcon: {
    display: 'flex',
    color: theme.palette.text.secondary,
  },
  // Alinhado à direita com largura mínima: os chips das várias linhas encostam na mesma borda, mas um
  // rótulo longo como "aguardando aprovação" ainda pode crescer em vez de ser cortado.
  statusSlot: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexShrink: 0,
    minWidth: 96,
  },
  statusChip: {
    height: 24,
    maxWidth: '100%',
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'uppercase',
    color: theme.palette.white,
  },
  // Uma classe por status do documento, alimentada pelo mesmo mapa de cores usado no módulo Documentos.
  statusActive: { backgroundColor: CHIP_STATUS_COLOR[ACTIVE_STATUS_ID] },
  statusDraft: { backgroundColor: CHIP_STATUS_COLOR[DRAFT_STATUS_ID] },
  statusInactive: { backgroundColor: CHIP_STATUS_COLOR[INACTIVE_STATUS_ID] },
  statusExpired: { backgroundColor: CHIP_STATUS_COLOR[EXPIRED_STATUS_ID] },
  statusAwaitingApproval: {
    backgroundColor: CHIP_STATUS_COLOR[AWAITING_APPROVAL_STATUS_ID],
  },
  statusUnknown: { backgroundColor: colors.grey[400] },
  // As duas ações andam juntas, encostadas na borda direita. Dar largura fixa a cada uma
  // separadamente abria um vão no meio da linha, porque a sobra de cada slot se somava ali.
  actions: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(1),
    flexShrink: 0,
  },
  // "Visualizar" e "Ocultar" têm larguras diferentes; a mínima evita que a ação seguinte dance entre
  // as linhas conforme o preview é aberto ou fechado.
  previewButton: {
    minWidth: 116,
  },
  // Reserva o mesmo espaço para o botão "Vincular" e para o chip "Vinculado".
  linkSlot: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexShrink: 0,
    width: 124,
  },
  linkButton: {
    width: '100%',
    whiteSpace: 'nowrap',
  },
  linkedChip: {
    width: '100%',
    height: 30,
    color: theme.palette.partnerGreen.dark,
    borderColor: theme.palette.partnerGreen.dark,
    fontWeight: theme.typography.fontWeightMedium,
    '& .MuiChip-icon': {
      color: theme.palette.partnerGreen.dark,
    },
  },
}))

export default styles
